import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { IExperimentSearchParams } from '../api/requests/ExperimentApiGateway';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

export interface useExperimentsCountResult {
    isLoaded: boolean;
    count: number | null;
}

export const useExperimentsCount = (searchParams: IExperimentSearchParams) => {
    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useExperimentsCountResult>({ isLoaded: false, count: null });

    useEffect(() => {
        setResult({ isLoaded: false, count: null });

        rootStore.experimentStore.countExperiments(searchParams)
            .then((count) => {
                setResult({ isLoaded: true, count: count });
            })
            .catch(e => publishNotification({
                text: `Error counting experiments: ${e.message}`,
                canClose: true
            }));
    }, [rootStore.experimentStore, publishNotification, searchParams, rootStore.gameVersionStore.currentGameVersion, rootStore.gameEnvironmentsStore.currentGameEnvironment]);

    return result;
};
